/* eslint-disable no-param-reassign */
import { produce } from 'immer';

/**
 * Updates the vehicle storage's drag event state in the store.
 *
 * @param {Function} set - The setter function for the zustand store.
 * @param {Function} get - The getter function for the zustand store.
 * @param {boolean} isDragging - Indicates whether there is an active drag operation.
 * @param {boolean} isVisualizerDrag - Indicates whether the drag is happening in the visualizer.
 * @returns {void} - The result of the set operation.
 */
export default (set, get, isDragging, isVisualizerDrag) => set(
  produce(get(), (draft) => {
    if (!draft.design) {
      draft.design = {};
    }

    draft.design.dragEvent = {
      isDragging,
      isVisualizerDrag,
    };

  }), false, { type: 'HANDLE_DRAG_EVENT' });
